export { default } from "./DialogTitle.mjs";
export { default as dialogTitleClasses } from "./dialogTitleClasses.mjs";
export * from "./dialogTitleClasses.mjs";